import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Spinner } from 'react-bootstrap';
import { useStrings } from '../../hooks/useStrings';

const SmartPassDownload = () => {
  const S = useStrings();
  const { uuid } = useParams<{ uuid: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!uuid) {
      setError(S.SMARTPASS_DOWNLOAD.INVALID_PASS_LINK);
      setLoading(false);
      return;
    }

    // Auto-detect device and redirect
    const userAgent = navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipad|ipod/.test(userAgent);
    const isAndroid = /android/.test(userAgent);

    const getApiBaseUrl = async (): Promise<string> => {
      if (window.location.hostname === 'localhost') {
        return window.location.origin;
      }
      try {
        const resp = await fetch('/assets/env.json');
        const env = await resp.json();
        if (env.apiUrl) return env.apiUrl;
      } catch { /* ignore */ }
      return window.location.origin;
    };

    const downloadPass = async () => {
      const apiBase = await getApiBaseUrl();

      if (isIOS) {
        // Direct download — iOS will offer "Add to Wallet"
        window.location.href = `${apiBase}/v1/smartpass/admin/passes/${uuid}/download`;
      } else if (isAndroid) {
        // Phase 2: Google Wallet save URL
        setError(S.SMARTPASS_DOWNLOAD.GOOGLE_WALLET_COMING_SOON);
        setLoading(false);
      } else {
        // Desktop — show instructions
        setError(S.SMARTPASS_DOWNLOAD.OPEN_ON_MOBILE);
        setLoading(false);
      }
    };

    downloadPass();
  }, [uuid]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div style={{ textAlign: 'center', color: 'white' }}>
          <Spinner animation="border" variant="light" />
          <p style={{ marginTop: '1rem' }}>{S.SMARTPASS_DOWNLOAD.PREPARING_PASS}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', padding: '1rem' }}>
      <Card style={{ maxWidth: '420px', width: '100%', borderRadius: '16px', border: 'none' }}>
        <Card.Body style={{ padding: '2rem', textAlign: 'center' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700 }}>{S.SMARTPASS_DOWNLOAD.TITLE}</h2>
          <p style={{ color: '#6c757d' }}>{error}</p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SmartPassDownload;
